import React from "react";
import "./AiLoaderSpeaking.css"; // Import the CSS file for styling

const AiLoaderSpeaking = () => {
  return (
    <div className="ai-loader-speaking">
      <span className="bar"></span>
      <span className="bar"></span>
      <span className="bar"></span>
    </div>
  );
};

export default AiLoaderSpeaking;
